import React from "react";
import CompanyBrand from "../subs/CompanyBrand.js";
import logo from "../../imgs/logo.png";

const Header = () => {

  return (
    <header>
      <section className="section_left">
        <CompanyBrand type={"normal"} logo={logo} />
      </section>
      <section className="section_right">
      </section>
    </header>
  );
}

export default Header;